var FHSPROD = FHSPROD || new Object();
FHSPROD.labelme = FHSPROD.labelme || new Object();
FHSPROD.labelme.labels = [{"id":5232,"name":"Label","position":"topright","position_prod_pg":null,"css_inline":"","css_class":"","priority":1,"height":50,"width":50,"type":0,"display_type":1,"size_type":1,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20181107094953.svg?4558489240039744858\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 1; width: 50%; height: 50%; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20181107094953.svg?4558489240039744858","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"1364257013804","title":"Hubnut\u00ed - v\u00fdhodn\u00fd bal\u00ed\u010dek produkt\u016f","handle":"hubnuti-vyhodny-balicek-produktu"}],"apply_collections":"47831580716"},{"id":3990,"name":"Label","position":"topright","position_prod_pg":null,"css_inline":"","css_class":"","priority":1,"height":47,"width":200,"type":0,"display_type":1,"size_type":0,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180504092655.svg?8878367420600233264\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 1; width: 200px; height: 47px; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180504092655.svg?8878367420600233264","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"734706892844","title":"Tempeh LIGHT \u010cesnek a koriandr BIO 200 g","handle":"copy-of-tempeh-light-stredomorsky"},{"id":"734708105260","title":"Tempeh LIGHT Curry BIO 200 g","handle":"copy-of-tempeh-light-cesnek-a-koriandr"},{"id":"734711349292","title":"Tempeh LIGHT Gyros BIO 200 g","handle":"tempeh-light-gyros"},{"id":"734716395564","title":"Tempeh LIGHT Letn\u00ed zahr\u00e1dka BIO 200 g","handle":"tempeh-light-letni-zahradka"},{"id":"734696603692","title":"Tempeh LIGHT Natural BIO 200 g","handle":"tempeh-light-natural"},{"id":"734706597932","title":"Tempeh LIGHT St\u0159edomo\u0159sk\u00fd BIO 200 g","handle":"tempeh-light-stredomorsky"}],"apply_collections":""},{"id":4005,"name":"Label","position":"topright","position_prod_pg":null,"css_inline":"","css_class":"","priority":99,"height":47,"width":200,"type":0,"display_type":1,"size_type":0,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054255.svg?17916086931216404847\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 200px; height: 47px; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054255.svg?17916086931216404847","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[],"apply_collections":"41862758444"},{"id":4006,"name":"Label","position":"topright","position_prod_pg":null,"css_inline":"","css_class":"","priority":99,"height":47,"width":200,"type":0,"display_type":1,"size_type":0,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054246.svg?10946801268213926668\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 200px; height: 47px; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054246.svg?10946801268213926668","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"751664267308","title":"LIFE BREAKFAST Kakaov\u00e1 proteinov\u00e1 sn\u00edda\u0148ov\u00e1 ka\u0161e s quinoou a sko\u0159ic\u00ed BIO RAW","handle":"life-breakfast-bio-raw-kase-kakaova-s-quinoou"},{"id":"791715282988","title":"LIFE BREAKFAST Malinovo-makadamiov\u00e1 sn\u00edda\u0148ov\u00e1 ka\u0161e s proteinem BIO RAW","handle":"life-breakfast-malinovo-makadamiova-snidanova-kase-s-proteinem-bio-raw"},{"id":"751645425708","title":"LIFE BREAKFAST Bor\u016fvkov\u00e1 sn\u00edda\u0148ov\u00e1 granola s proteinem a chia sem\u00ednky BIO RAW","handle":"life-breakfast-bio-raw-granola-cokoladova-s-mandlemi"},{"id":"747828412460","title":"LIFE BREAKFAST \u010cokol\u00e1dov\u00e1 sn\u00edda\u0148ov\u00e1 granola s proteinem a mandlemi BIO RAW","handle":"test_dm"},{"id":"834473426988","title":"SN\u00cdDEJ SLADCE bez p\u0159idan\u00e9ho cukru! (ban\u00e1n - RAW kakaov\u00e9 boby) BIO","handle":"snidej-sladce-bez-pridaneho-cukru-banan-neprazene-kakaove-boby"},{"id":"834518286380","title":"SN\u00cdDEJ SLADCE bez p\u0159idan\u00e9ho cukru! (RAW kakao- goji) BIO","handle":"snidej-sladce-bez-pridaneho-cukru-kakao-goji"},{"id":"893103013932","title":"RAW med kv\u011btov\u00fd 750 g","handle":"raw-med-kvetovy"},{"id":"893129097260","title":"RAW med pohankov\u00fd 750 g","handle":"raw-med-pohankovy-750-g"},{"id":"863893389356","title":"BIO RAW protein PLUS SUNWARRIOR natural 1kg","handle":"bio-raw-protein-plus-sunwarrior-natural-1kg"},{"id":"862870732844","title":"BIO RAW r\u00fd\u017eov\u00fd protein SUNWARRIOR \u010dokol\u00e1dov\u00fd 1kg","handle":"bio-raw-ryzovy-protein-sunwarrior-cokoladovy-1kg"},{"id":"862868373548","title":"BIO RAW r\u00fd\u017eov\u00fd protein SUNWARRIOR vanilkov\u00fd 1kg","handle":"bio-raw-ryzovy-protein-sunwarrior-vanilkovy-1kg"},{"id":"814891925548","title":"Brusinky su\u0161en\u00e9 BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"brusinky-susene-bio"},{"id":"815205908524","title":"\u010cesk\u00e1 su\u0161en\u00e1 hru\u0161ka pl\u00e1tky BIO RAW (balen\u00ed 60g\/1kg)","handle":"ceska-susena-hruska-platky-bio-raw"},{"id":"815219769388","title":"\u010cesk\u00e1 \u0161vestka su\u0161en\u00e1 BIO RAW (balen\u00ed 80g\/1kg)","handle":"ceska-svestka-susena-bio-raw"},{"id":"814876459052","title":"Chia sem\u00ednka BIO RAW (balen\u00ed 250g\/500g\/1kg)","handle":"chia-seminka-bio-raw"},{"id":"815177728044","title":"Datle su\u0161en\u00e9 bez pecek BIO RAW (balen\u00ed 200g\/1kg)","handle":"datle-susene-bez-pecek-bio-raw"},{"id":"815129657388","title":"Goji su\u0161en\u00e9 BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"goji-susene-bio-raw"},{"id":"815424438316","title":"Jablka - \u010cesk\u00e1 k\u0159\u00ed\u017eala BIO RAW","handle":"jablka-ceska-krizala-bio-raw"},{"id":"815381872684","title":"Ke\u0161u o\u0159echy BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"kesu-orechy-bio-raw"},{"id":"791855988780","title":"Lifebar \u010derven\u00e1 \u0159epa BIO RAW","handle":"lifebar-cervena-repa-bio-raw"},{"id":"791881056300","title":"Lifebar Plus \u010dokol\u00e1dov\u00e1 s konopn\u00fdm proteinem BIO RAW","handle":"lifebar-plus-cokoladova-s-konopnym-proteinem-bio-raw"},{"id":"791889805356","title":"Lifebar Plus s chia sem\u00ednky a mlad\u00fdm je\u010dmenem BIO RAW","handle":"lifebar-plus-s-chia-seminky-a-mladym-jecmenem-bio-raw"},{"id":"791827349548","title":"Lifebar Protein jahodov\u00e1 BIO RAW","handle":"lifebar-protein-jahodova-bio-raw"},{"id":"791848255532","title":"Lifebar Protein malinov\u00e1 BIO RAW","handle":"lifebar-protein-malinova-bio-raw"},{"id":"791873421356","title":"Lifebar t\u0159e\u0161\u0148ov\u00e1 BIO RAW","handle":"lifebar-tresnova-bio-raw"},{"id":"815321514028","title":"L\u00edskov\u00e9 o\u0159echy BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"liskove-orisky-bio-raw"},{"id":"815266922540","title":"Mandle natural BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"mandle-natural-bio-raw"},{"id":"872497315884","title":"Marawk\u00e1nka RAW BIO 30 g","handle":"marawkanka-raw-bio-30-g"},{"id":"814882848812","title":"Meru\u0148kov\u00e1 j\u00e1dra sladk\u00e1 BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"merunkova-jadra-sladka-bio-raw"},{"id":"814830256172","title":"Pist\u00e1cie loupan\u00e9 BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"pistacie-loupane-bio-raw"},{"id":"815163244588","title":"Rozinky Green Khorog BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"rozinky-green-khorog-bio-raw"},{"id":"864047202348","title":"Ty\u010dinka ovocn\u00e1 s p\u0159\u00edchut\u00ed brusinky  RAW\u00a0ME","handle":"tycinka-ovocna-s-prichuti-brusinky-raw-me"},{"id":"864059031596","title":"Ty\u010dinka ovocn\u00e1 s p\u0159\u00edchut\u00ed jablka RAW\u00a0ME","handle":"tycinka-ovocna-s-prichuti-jablka-raw-me"},{"id":"864066142252","title":"Ty\u010dinka ovocn\u00e1 s p\u0159\u00edchut\u00ed manga RAW\u00a0ME","handle":"tycinka-ovocna-s-prichuti-manga-raw-me"},{"id":"814842478636","title":"Vla\u0161sk\u00e9 o\u0159echy BIO RAW (balen\u00ed 100g\/500g\/1kg)","handle":"vlasske-orechy-bio-raw"},{"id":"834573631532","title":"BUDDHA\u2019S AWAKENING \u2013 A\u00e7a\u00ed & jahoda","handle":"buddha-s-awakening-acai-jahoda"},{"id":"834599780396","title":"BUDDHA\u2019S AWAKENING \u2013 Kakao","handle":"buddha-s-awakening-kakao"},{"id":"834602696748","title":"BUDDHA\u2019S AWAKENING \u2013 Maca & vanilka","handle":"buddha-s-awakening-maca-vanilka"}],"apply_collections":""},{"id":4007,"name":"Label","position":"topleft","position_prod_pg":null,"css_inline":"","css_class":"","priority":99,"height":47,"width":200,"type":0,"display_type":1,"size_type":0,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054233.svg?14888094125559004663\"); background-position: 0% 0%; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 200px; height: 47px; opacity: 1; position: absolute; top: 0%; left: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054233.svg?14888094125559004663","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[],"apply_collections":""},{"id":4008,"name":"Label","position":"topright","position_prod_pg":null,"css_inline":"","css_class":"","priority":99,"height":47,"width":200,"type":0,"display_type":1,"size_type":0,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054225.svg?17062619280479673973\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 200px; height: 47px; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054225.svg?17062619280479673973","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"865847509036","title":"Va\u0159en\u00e1 \u010do\u010dka s cizrnou BIO 250 g","handle":"varena-cocka-s-cizrnou-bio-250-g"},{"id":"865841840172","title":"Va\u0159en\u00e1 quinoa s olejnat\u00fdmi semeny BIO 220 g","handle":"varena-quinoa-s-olejnatymi-semeny-bio-220-g"},{"id":"873926950956","title":"Cizrna marock\u00e1 sterilovan\u00e1 BIO 560 g","handle":"cizrna-marocka-sterilovana-bio-560-g"},{"id":"869717573676","title":"Chipsy s D\u00dd\u0147OVOU moukou 100 g","handle":"chipsy-s-dynovou-moukou-100-g"},{"id":"869710987308","title":"Chipsy lu\u0161t\u011bninov\u00e9 s CHIA a ROZMAR\u00ddNEM 100 g","handle":"chipsy-lusteninove-s-chia-a-rozmarynem-100-g"},{"id":"869687230508","title":"Chipsy lu\u0161t\u011bninov\u00e9 s \u010cERVENOU \u0158EPOU 100 g","handle":"chipsy-s-cervenou-repou-100-g"},{"id":"869069226028","title":"Biosaurus k\u0159upky BIO s p\u0159\u00edchut\u00ed KE\u010cUP 50 g","handle":"biosaurus-krupky-bio-s-prichuti-kecup-50-g"},{"id":"860643983404","title":"Chipsy BIO raj\u010datov\u00e9 AMAIZIN 100 g","handle":"chipsy-bio-kukuricne-rajcatove-amaizin-100-g"},{"id":"1445454512172","title":"Du\u0161en\u00e1 sm\u011bs hr\u00e1\u0161ek BIO 400g","handle":"dusena-smes-hrasek-bio-400g"}],"apply_collections":"42004021292;41992618028;41773432876;42059202604"},{"id":4009,"name":"Label","position":"topright","position_prod_pg":null,"css_inline":"","css_class":"","priority":99,"height":47,"width":200,"type":0,"display_type":1,"size_type":0,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054215.svg?11837975734398804528\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 200px; height: 47px; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054215.svg?11837975734398804528","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"864258424876","title":"Ka\u0161e ","handle":"dezert-pohankovy-bio-140g"},{"id":"864450641964","title":"Ka\u0161e \u010dirokov\u00e1 bezlepkov\u00e1 NOMINA 300 g","handle":"kase-cirokova-bezlepkova-nomina-300-g"},{"id":"864429932588","title":"Ka\u0161e j\u00e1hlov\u00e1 bezlepkov\u00e1 NOMINA 300 g","handle":"kase-jahlova-bezlepkova-nomina-300-g"},{"id":"864442449964","title":"Ka\u0161e pohankov\u00e1 bezlepkov\u00e1 NOMINA 300 g","handle":"kase-pohankova-bezlepkova-nomina-300-g"},{"id":"834642346028","title":"Iswari Sports PERFORMANCE ka\u0161e (before) 600g","handle":"iswari-sports-performance-kase-before"},{"id":"861886906412","title":"ARRABBIATA om\u00e1\u010dka na t\u011bstoviny BIO 340g","handle":"omacka-bolonska-zeleninova-bio-350g"},{"id":"869226676268","title":"Bio TYGR d\u011btsk\u00e1 om\u00e1\u010dka na t\u011bstoviny BIO bez cukru 360 g","handle":"bio-tygr-detska-omacka-na-testoviny-360-g"},{"id":"869167824940","title":"FAMILIA om\u00e1\u010dka na t\u011bstoviny BIO 550g","handle":"familia-omacka-na-testoviny-550g"},{"id":"869199937580","title":"TOSKANA om\u00e1\u010dka na t\u011bstoviny BIO 550g","handle":"toskana-omacka-na-testoviny-bio-550g"},{"id":"862736711724","title":"Ke\u010dup BIO TIGER bez cukru 500ml","handle":"kecup-bio-bez-cukru-500ml"},{"id":"862588436524","title":"D\u017eem f\u00edk DALFOUR bez cukru 284 g","handle":"dzem-fik-dalfour-284-g"},{"id":"862574936108","title":"D\u017eem jahoda DALFOUR bez cukru 284 g","handle":"dzem-jahoda-dalfour-284-g"},{"id":"862568644652","title":"D\u017eem malina DALFOUR bez cukru 284 g","handle":"dzem-malina-dalfour-284-g"},{"id":"862563926060","title":"D\u017eem meru\u0148ka DALFOUR bez cukru 284 g","handle":"dzem-merunka-dalfour-dalfour-284-g"},{"id":"862555209772","title":"D\u017eem ovocn\u00fd brusinka a bor\u016fvka bez cukru DALFOUR 284 g","handle":"dzem-ovocny-brusinka-a-boruvka-dalfour-284-g"},{"id":"862551769132","title":"D\u017eem ovocn\u00fd pomeran\u010d a z\u00e1zvor bez cukru DALFOUR 284 g","handle":"dzem-ovocny-pomeranc-a-zazvor-284-g"},{"id":"858342326316","title":"Ty\u010dinka BIO BAN\u00c1N-JABLKO","handle":"bio-tycinka-banan-jablko-40-g"},{"id":"858330759212","title":"Ty\u010dinka BIO BRUSINKA-KE\u0160U","handle":"bio-tycinka-brusnice-kesu-40-g"},{"id":"858338787372","title":"Ty\u010dinka BIO JABLKO","handle":"bio-tycinka-jablko-40-g"},{"id":"858325712940","title":"Ty\u010dinka BIO KAKAO-POMERAN\u010c","handle":"bio-tycinka-kakao-pomeranc-40-g"},{"id":"858335313964","title":"Ty\u010dinka BIO MANGO-BAOBAB","handle":"bio-tycinka-mango-baobab-40-g"},{"id":"858321420332","title":"Ty\u010dinka BIO s p\u0159\u00edchut\u00ed OVOCE","handle":"bio-tycinka-ovoce-40-g"},{"id":"858440663084","title":"Brusinkov\u00fd sirup BIO 500ml","handle":"brusinkovy-sirup-bio-0-5-l"},{"id":"858451738668","title":"Malinov\u00fd sirup BIO 500ml","handle":"malinovy-sirup-bio-0-5-l"},{"id":"858459963436","title":"Sirup z\u00e1zvor - citron BIO 500ml","handle":"sirup-zazvor-citron-bio-0-5l-vegan"},{"id":"897280606252","title":"Kokosov\u00e1 voda 500 ml","handle":"kokosova-voda-500-ml"}],"apply_collections":"41851682860;42292674604;41174204460"},{"id":4010,"name":"Label","position":"topright","position_prod_pg":null,"css_inline":"","css_class":"","priority":99,"height":47,"width":200,"type":0,"display_type":1,"size_type":0,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054204.svg?6118528256081316919\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 200px; height: 47px; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511054204.svg?6118528256081316919","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"858438139948","title":"Sbohem, soli! - Pikantn\u00ed (ko\u0159en\u00edc\u00ed p\u0159\u00edpravek) BIO 50g","handle":"sbohem-soli-pikantni-korenici-pripravek-bio-50g"},{"id":"858417365036","title":"Sbohem, soli! - St\u0159edomo\u0159sk\u00e1 (ko\u0159en\u00edc\u00ed p\u0159\u00edpravek) BIO 55g","handle":"sbohem-soli-stredomorska-korenici-pripravek-bio-55g"},{"id":"858427654188","title":"Sbohem, soli! - Zeleninov\u00e1 (ko\u0159en\u00edc\u00ed p\u0159\u00edpravek) BIO 60g","handle":"sbohem-soli-zeleninova-korenici-pripravek-bio-60g"},{"id":"861762355244","title":"Buj\u00f3n zeleninov\u00fd BIO bez soli","handle":"bujon-zeleninovy-se-snizenym-obsahem-soli"},{"id":"864085671980","title":"Tahini 100% sezamov\u00e1 pasta BIO bez soli 250 g","handle":"tahini-bio-bez-soli-350-g"},{"id":"900619337772","title":"K\u0159upky BIO kuku\u0159i\u010dn\u00e9 Angelina MRKEV a JABLKO 60 g","handle":"krupky-bio-kukuricne-angelina-mrkev-a-jablko-60-g"},{"id":"900622286892","title":"K\u0159upky BIO kuku\u0159i\u010dn\u00e9 Teddy MRKEV a D\u00ddN\u011a 60 g","handle":"krupky-bio-kukuricne-teddy-mrkev-a-dyne-60-g"}],"apply_collections":""},{"id":4012,"name":"Label","position":"topright","position_prod_pg":"","css_inline":"","css_class":"","priority":99,"height":47,"width":200,"type":0,"display_type":1,"size_type":0,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511062748.svg?12134438181351225482\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 200px; height: 47px; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20180511062748.svg?12134438181351225482","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"897304395820","title":"R\u00fd\u017eov\u00fd BIO n\u00e1poj BERIEF 1000 ml","handle":"ryzove-mleko-bio-1000-ml"},{"id":"3882145841196","title":"R\u00fd\u017eov\u00fd BIO n\u00e1poj Alnatura 1000 ml","handle":"ryzovy-bio-napoj-alnatura-1000-ml"},{"id":"3900012363820","title":"R\u00fd\u017eov\u00fd BIO n\u00e1poj Alnatura s v\u00e1pn\u00edkem 1000 ml","handle":"ryzovy-bio-napoj-alnatura-s-vapnikem-1000-ml"}],"apply_collections":"42047668268"},{"id":5064,"name":"Label","position":"topright","position_prod_pg":null,"css_inline":"","css_class":"","priority":99,"height":50,"width":50,"type":0,"display_type":1,"size_type":1,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20181018090524.svg?9798761962195839054\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 50%; height: 50%; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20181018090524.svg?9798761962195839054","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"865315323948","title":"Xylitol BIO 250 g","handle":"xylitol-bio-350-g"},{"id":"1092595089452","title":"Ln\u011bn\u00e9 sem\u00ednko odr\u016fda Natural BIO 250 g","handle":"lnene-seminko-odruda-natural-bio-250-g"}],"apply_collections":""},{"id":5065,"name":"Label","position":"topright","position_prod_pg":"","css_inline":"","css_class":"","priority":99,"height":50,"width":50,"type":0,"display_type":1,"size_type":1,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20181018090421.svg?6149505286947808424\"); background-position: right top; background-size: contain; background-repeat: no-repeat; z-index: 99; width: 50%; height: 50%; opacity: 1; position: absolute; top: 0%; right: 0%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/0015\/6762\/1164\/t\/5\/assets\/fhs_svg_20181018090421.svg?6149505286947808424","display_text":"","new_threshold":null,"new_start_dt":"01\/22\/2022","new_end_dt":"01\/22\/2022","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"01\/22\/2022","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"4248083234860","title":"Naj\u00edm se a zhubnu: Recepty pro celou rodinu","handle":"najim-se-a-zhubnu-recepty-pro-celou-rodinu"}],"apply_collections":""}];
FHSPROD.labelme.settings = {"add_wrapper":0,"show_on_all_variant_images":1,"mobile_ratio":"0.75","max_viewpot_ratio":"0.75","viewpot_ratio":"0.65","max_mobile_screen_width":425,"support_mobile":1,"support_small_viewpot":0,"wrap_exact_img_tag":0,"show_collection_page":1,"show_product_page":1,"show_product_page_related":0,"stop_on_first_image":0,"scale_on_hover":1,"show_multiple_labels":1,"selector_prod":null,"selector_coll":null,"selector_prod_ext":null,"selector_coll_ext":null,"label_class_ext":null,"label_style_ext":null,"label_coll_class_ext":null,"label_coll_style_ext":null,"observer_selector":null,"observer_enable":0,"show_on_search_page":0,"allow_search_product":"1"};

var loadScript = function (url, callback){
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState == 'loaded' || script.readyState == 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        script.onreadystatechange = callback;
        script.onload = callback;
    }
    script.src = url;
    document.head.appendChild(script);
};
var labelInit = function (FHSPROD, jQuery) {
	
    //console.debug('labelInit()');
    jQuery.cookie = function (b, j, m) {
        if (typeof j != 'undefined') {
            m = m || {};
            if (j === null) {
                j = '';
                m.expires = -1;
            }
            var e = '';
            if (m.expires && (typeof m.expires == 'number' || m.expires.toUTCString)) {
                var f;
                if (typeof m.expires == 'number') {
                    f = new Date();
                    f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000));
                } else {
                    f = m.expires;
                }
                e = '; expires=' + f.toUTCString();
            }
            var l = m.path ? '; path=' + (m.path) : '';
            var g = m.domain ? '; domain=' + (m.domain) : '';
            var a = m.secure ? '; secure' : '';
            document.cookie = [b, '=', encodeURIComponent(j), e, l, g, a].join('');
        } else {
            var d = null;
            if (document.cookie && document.cookie != '') {
                var k = document.cookie.split(';');
                for (var h = 0; h < k.length; h++) {
                    var c = jQuery.trim(k[h]);
                    if (c.substring(0, b.length + 1) == (b + '=')) {
                        d = decodeURIComponent(c.substring(b.length + 1));
                        break;
                    }
                }
            }
            return d;
        }
    };
    FHSPROD.labelCookie = {
        name: 'fhs_label_me',
        setCookieStatus: function () { //installed, failed, re-installed, expired
            jQuery.cookie(this.name, 'installed');
        }
    };
    FHSPROD.labelCookie.setCookieStatus();
    if (FHSPROD.labelme.loadedApp === true) {
        return;
    }
    if ((typeof FHSPROD) == 'undefined') {
        var FHSPROD = {};
    }
    if ((typeof FHSPROD.labelme) == 'undefined') {
        FHSPROD.labelme = {};
    }
    if ((typeof FHSPROD.labelme.labels) == 'undefined') {
    	FHSPROD.labelme.labels = [];
    }
    if ((typeof FHSPROD.labelme.settings) == 'undefined') {
    	FHSPROD.labelme.settings = {'add_wrapper':0,'max_mobile_screen_width':425,'max_viewpot_ratio':0.75,'mobile_ratio':0.65
    		,'show_on_all_variant_images':0,'support_mobile':1,'support_small_viewpot':1,'viewpot_ratio':0.65 
    		,'wrap_exact_img_tag':0, 'show_collection_page':1,'show_product_page':1,'show_product_page_related':1, 'stop_on_first_image':0, 'scale_on_hover':1, 'show_multiple_labels':0};
    }
    if ((typeof FHSPROD.themeName) === 'undefined') {
    	FHSPROD.themeName = 'unknown';
    	if(Shopify && Shopify.theme){
    		if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('venture')  >= 0){
    			FHSPROD.themeName = 'venture';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('minimal')  >= 0){
    			FHSPROD.themeName = 'minimal';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('debut')  >= 0){
    			FHSPROD.themeName = 'debut';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('narrative')  >= 0){
    			FHSPROD.themeName = 'narrative';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('jumpstart')  >= 0){
    			FHSPROD.themeName = 'jumpstart';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('boundless')  >= 0){
    			FHSPROD.themeName = 'boundless';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('simple')  >= 0){
    			FHSPROD.themeName = 'simple';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('brooklyn')  >= 0){
    			FHSPROD.themeName = 'brooklyn';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('pop')  >= 0){
    			FHSPROD.themeName = 'pop';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('supply')  >= 0){
    			FHSPROD.themeName = 'supply';
    		}else if(Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('launchpad')  >= 0){
    			FHSPROD.themeName = 'launchpad';
    		}
    	}
    }
    FHSPROD.isDefined = function (obj) {
        return ((typeof obj == 'undefined') ? false : true);
    };
    FHSPROD.getPositionLeft = function (elem, strCssRule) {
        return 0;
    };
    FHSPROD.getPositionTop = function (elem, strCssRule) {
        return 0;
    };
    FHSPROD.getMarginW = function (elem, strCssRule) {
        var bordT = elem.outerWidth() - elem.innerWidth();
        var paddT = elem.innerWidth() - elem.width();
        var margT = elem.outerWidth(true) - elem.outerWidth();
        return margT / 2;
    };
    FHSPROD.getMarginH = function (elem, strCssRule) {
        var bordT = elem.outerHeight() - elem.innerHeight();
        var paddT = elem.innerHeight() - elem.height();
        var margT = elem.outerHeight(true) - elem.outerHeight();
        return margT / 2;
    };
    FHSPROD.getPadding = function (elem, strCssRule) {
        var bordT = elem.outerWidth() - elem.innerWidth();
        var paddT = elem.innerWidth() - elem.width();
        var margT = elem.outerWidth(true) - elem.outerWidth();
        return paddT;
    };
    FHSPROD.labelme.labelMain = function (variantId, image) {
        var product = FHSPROD.labelme.product_main;
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            if (variantId == variant.id) {
                break;
            }
        }
        var match_count = 0;
        var labels = FHSPROD.labelme.labels;
        for (var id in labels) {
            var label = labels[id];

            //exclude products
            if(label.type != 0 && label.exclude_products && label.exclude_products.indexOf(product.id) >= 0){
            	continue;
            }
            
            //exclude collections
            //allow label.type != 0 && since 06 Nov 2017
            if(label.exclude_collections){
            	var ids = label.exclude_collections.split(',');
            	var is_excluded = false;
        		for (var i = 0; i < ids.length; i++) {
        			if(product.collection_ids.indexOf(ids[i]) >=0 ){
        				is_excluded = true;
            			break;
            		}    
        		}
        		if(is_excluded == true) continue;
            }
            
            //exclude tags
            //remove label.type != 0 && since 06 Nov 2017
            if(label.exclude_tags && label.exclude_tags.length > 0){
            	var tags = label.exclude_tags.split(',');
            	for(var i=0; i< tags.length; i++){
            		if(product.tags && product.tags.indexOf(tags[i]) >= 0){
            			is_excluded = true;
            			break;
            		}
            	}
            	if(is_excluded == true) continue;
            }
            
            var condition = label.conditions;
            
            if (label.hide) {
                if (match_count > 0) {
                    continue;
                }
            }
            
            if(label.hasOwnProperty('show_on_product_pg') && label.show_on_product_pg == 0){
            	continue;
            }
            
            match = FHSPROD.labelme.matchLabel(product, label, image, FHSPROD.labelme.showMatchLabelSingle);
            
            if (match) {
                match_count++;
                if(FHSPROD.labelme.settings.show_multiple_labels && FHSPROD.labelme.settings.show_multiple_labels == 1){
                	continue;
                }else{
                	break;
                }
            } else {
                continue;
            }
            
            
        }
    };
    FHSPROD.labelme.showMatchLabelSingle = function (product, label, image, display_text ){
    	
    	var $image = jQuery(image);
    	var pwidth = $image.width();
    	var pheight = $image.height();
	    //console.debug('labelMain()');
    	
    	var $flickity = jQuery(image).parents('.flickity-viewport');
    	var $imageParent;
    	if($flickity.length > 0){
    		$imageParent = $flickity.first();
    	}else{
    		$imageParent = jQuery(image).parents(':not(a):not(ul):not(li)').first();
    	}
    	var $parent = $imageParent.parent();
    	//$imageParent.detach();
    	
        $imageParent.addClass('fhs-parent');
        
        if(FHSPROD.labelme.settings.add_wrapper == 1){
		    //jQuery(image).parents(':not(a)').eq(0).wrap(jQuery(fhswrapper));
	        if($imageParent.parent().hasClass('fhs-wrapper') == false){
	        	var $plcontainer = jQuery('<div class=\"fhs-wrapper fhs-product\">').css({
	    			//width: image.width(),
	    			//height: image.height(),
	    			//'margin-left': FHSPROD.getMarginW($image),
	    			//'margin-right': FHSPROD.getMarginW($image),
	    			//'margin-top': FHSPROD.getMarginH($image),
	    			//'margin-bottom': FHSPROD.getMarginH($image),
	    			//'position': 'relative',
	    			//padding: FHSPROD.getPadding($image),
	    		});
	        	$imageParent.wrap($plcontainer);
			}
	        //jQuery('.fhs-wrapper .fhs-image').hide();
        }else{
        	$imageParent.css('position','relative');
        }
    	
    	var labelNodes = $imageParent.find('.fhs-image[data-label-id=\"' + label.id + '\"]');
        if (labelNodes.length > 0) {
            labelNodes.first().show();
        } else {
    		
    		var $newNode = jQuery('<div>');
    		$newNode.attr('data-label-id',label.id ).attr('class','fhs-image ' + label.css_class ).attr('style', label.div_style + label.css_inline);
    		var $textNode = jQuery('<div>');
    		$textNode.attr('style',label.text_style).text(display_text);    
    		$newNode.append($textNode);
            
    		var pos = label.position;
    		//var style = 'position: absolute;';
    		$newNode.css('position', 'absolute');
    		if('custom' == pos){
    			//top left already in div_style
    		}else if('topleft' == pos){
    			//style += 'top:0%;left:0%;';
    			$newNode.css('top', '0%');
    			$newNode.css('left', '0%');
    		}else if('topright' == pos){
    			//style += 'top:0%;right:0%;';
    			$newNode.css('top', '0%');
    			$newNode.css('right', '0%');
    		}else if('topcenter' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'top:0%;left:'+ csize + '%'+';';
    			$newNode.css('top', '0%');
    			$newNode.css('left', csize+'%');
    		}else if('bottomleft' == pos){
    			//style += 'bottom:0%;left:0%;';
    			$newNode.css('bottom', '0%');
    			$newNode.css('left', '0%');
    		}else if('bottomright' == pos){
    			//style += 'bottom:0%;right:0%;';
    			$newNode.css('bottom', '0%');
    			$newNode.css('right', '0%');
    		}else if('bottomcenter' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'bottom:0%;left:'+ csize + '%'+';';
    			$newNode.css('bottol', '0%');
    			$newNode.css('left', csize + '%');
    		}else if('leftcenter' == pos){
    			var csize = label.size_type==0?(((pheight-label.height)/2)/pheight)*100:(((100-label.height)/2));
    			//style += 'top:'+ csize + '%'+';left:0%;';
    			$newNode.css('top', csize + '%');
    			$newNode.css('left', '0%');
    		}else if('rightcenter' == pos){
    			var csize = label.size_type==0?(((pheight-label.height)/2)/pheight)*100:(((100-label.height)/2));
    			//style += 'top:'+ csize + '%'+';right:0%;';
    			$newNode.css('top', csize + '%');
    			$newNode.css('right', '0%');
    		}else if('center' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'top:'+ csize + '%'+';left:'+ csize + '%'+';';
    			$newNode.css('top', csize + '%');
    			$newNode.css('left',csize + '%');
    		}
    		//20 April 2017:  changed to append image to the imageParent instead of .fhs-wrapper
            //jQuery('.fhs-wrapper').append(newNode)
            //jQuery(imageParent).prepend(newNode);
    		
    		insertLabel($imageParent, label, pwidth, pheight, $newNode, display_text);
        }
        
        //$parent.append($imageParent);
    };
    FHSPROD.labelme.matchLabel = function (product, label, image, callback){
    	
    	var type = label.type;
        var display_text = label.display_text;
        var match = false;
        
        //include tags
        if(label.include_tags && label.include_tags.length > 0){
        	var tags = label.include_tags.split(',');
        	for(var i=0; i< tags.length; i++){
        		if(product.tags && product.tags.indexOf(tags[i]) >= 0){
        			match = true;
        			break;
        		}
        	}
        }
        
    	if(label.apply_collections && label.apply_collections != ''){
        	if(product.collection_ids){
        		var ids = label.apply_collections.split(';');
        		for (var i = 0; i < ids.length; i++) {
        			if(product.collection_ids.indexOf(ids[i]) >=0 ){
            			match = true;
            			break;
            		}    
        		}
        	}
        }
        if(label.apply_products && label.apply_products.length > 0){
        	/*jQuery.each(label.apply_products, function (i, p) {
            if(p.handle === product.handle || p.id == product.id){
    			match = true;
    			return false;
    		}
	        });*/
	    	var apply_products_length = label.apply_products.length;
	    	for(var i=0; i< apply_products_length; i++){
	    		var p = label.apply_products[i];
	    		if(p.handle === product.handle || p.id == product.id){
	    			match = true;
	    			break;
	    		}
	    	}
        }
        if(type == 5){ //5=out of stock
        	if(product.total_quantity && product.total_quantity == 0){
        		match = true;
        	}else{
				var vlen = product.variants.length;
				
				if(vlen > 0){ //process variants				
					var submatch = true;
					for(var i=0; i< vlen; i++){
						submatch = submatch &&(product.variants[i].quantity == 0);
					}
					match = submatch;
				}
			}
        }else if(type == 4){ //4=low stock quantity
        	if ( product.total_quantity > 0 && product.total_quantity  <= label.low_stock_quantity  ) {
        		if(display_text.indexOf('$q') >= 0){
        			display_text = display_text.replace('$q', product.total_quantity);
        		}
        		match = true;
            }
        }else if(type == 3){ //1=new, 2=sale,3=others

        	if (label.expi_dt) {
        		var newDate = new Date();
                if (Date.parse(label.expi_dt) >= Date.parse(newDate.toString())) {
                    match = true;
                }
            }

        }else if(type == 2){
        	var vlen = product.variants.length;
        	if(vlen > 0){ //process variants
        		var subMatch = false;
        		
        		for(var i=0; i< vlen; i++){
        			var v = product.variants[i];
        			if (v.compare_at_price_min && v.compare_at_price_min > 0 && v.price < v.compare_at_price_min) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price_min - v.price) / v.compare_at_price_min)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price_min - v.price) / v.compare_at_price_min)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price_min - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price_min - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }else if (v.compare_at_price_max && v.compare_at_price_max > 0 && v.price < v.compare_at_price_max) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price_max - v.price) / v.compare_at_price_max)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price_max - v.price) / v.compare_at_price_max)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price_max - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price_max - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }else if (v.compare_at_price && v.compare_at_price > 0  && v.price < v.compare_at_price) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price - v.price) / v.compare_at_price)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price - v.price) / v.compare_at_price)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }
        			
        			if(subMatch) {
        				break;
        			}
        		}
        		
        		if(match == false) {
        			match = subMatch;
        		}
        	}else{ //product does not have any variant
        		if (product.compare_at_price_min && product.compare_at_price_min > 0 && product.price < product.compare_at_price_min) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price_min - product.price) / product.compare_at_price_min)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price_min - product.price) / product.compare_at_price_min)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price_min - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price_min - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }else if (product.compare_at_price_max && product.compare_at_price_max > 0 && product.price < product.compare_at_price_max) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price_max - product.price) / product.compare_at_price_max)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price_max - product.price) / product.compare_at_price_max)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price_max - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price_max - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }else if (product.compare_at_price && product.compare_at_price > 0  && product.price < product.compare_at_price) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price - product.price) / product.compare_at_price)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price - product.price) / product.compare_at_price)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }
        	}
        	
        }else if(type == 1){
        	
			 if (label.new_start_dt && label.new_end_dt) {
				 if(product.published_at_max && Date.parse(product.published_at_max.substring(0,10)) >= Date.parse(label.new_start_dt)
				 	&& Date.parse(product.published_at_max.substring(0,10)) <= Date.parse(label.new_end_dt)){
					 match = true;
				 }
				 if (product.published_at_min && Date.parse(product.published_at_min.substring(0,10)) >= Date.parse(label.new_start_dt)
				 	&& Date.parse(product.published_at_min.substring(0,10)) <= Date.parse(label.new_end_dt)) {
					 match = true;
				 }
				if (product.created_at && Date.parse(product.created_at.substring(0,10)) >= Date.parse(label.new_start_dt)
					&& Date.parse(product.created_at.substring(0,10)) <= Date.parse(label.new_end_dt)) {
					 match = true;
				 }				 
				 if(product.published_at && Date.parse(product.published_at.substring(0,10)) >= Date.parse(label.new_start_dt)
						 && Date.parse(product.published_at.substring(0,10)) <= Date.parse(label.new_end_dt)){
					 match = true;
				 }
			 }
    	
    		if(label.new_threshold > 0){
				var newDate = new Date();
				newDate.setDate(newDate.getDate() - label.new_threshold);
				if(product.published_at && Date.parse(product.published_at.substring(0,10)) >= Date.parse(newDate.toString())){
					 match = true;
				}
				if(product.created_at && Date.parse(product.created_at.substring(0,10)) >= Date.parse(newDate.toString())){
					 match = true;
				}
				if (product.published_at_min && Date.parse(product.published_at_min.substring(0,10)) >= Date.parse(newDate.toString())){
					 match = true;
				}
				 if(product.published_at_max && Date.parse(product.published_at_max.substring(0,10)) >= Date.parse(newDate.toString())){
					 match = true;
				 }
			 }
        }
        if(match){
        	callback(product, label, image, display_text);
        }
        return match;
    };
    FHSPROD.labelme.labelList = function (product, image) {
        var match_count = 0;
        var labels = FHSPROD.labelme.labels;
        for (var id in labels) {
            var label = labels[id];
            
            //exclude products
            //remove label.type != 0 && since 06 Nov 2017 
            if(label.exclude_products && label.exclude_products.indexOf(product.id) >= 0){
            	continue;
            }
            
            //exclude collections
            //remove label.type != 0 && since 06 Nov 2017
            if(label.exclude_collections){
            	var ids = label.exclude_collections.split(',');
            	var is_excluded = false;
        		for (var i = 0; i < ids.length; i++) {
        			if(product.collection_ids.indexOf(ids[i]) >=0 ){
        				is_excluded = true;
            			break;
            		}    
        		}
        		if(is_excluded == true) continue;
            }
            
            //exclude tags
            //remove label.type != 0 && since 06 Nov 2017
            if(label.exclude_tags && label.exclude_tags.length > 0){
            	var tags = label.exclude_tags.split(',');
            	for(var i=0; i< tags.length; i++){
            		if(product.tags && product.tags.indexOf(tags[i]) >= 0){
            			is_excluded = true;
            			break;
            		}
            	}
            	if(is_excluded == true) continue;
            }
            
            var match = false;
            if (label.hide) {
                if (match_count > 0) {
                    continue;
                }
            }
            
            if(label.hasOwnProperty('show_on_collection_pg') && label.show_on_collection_pg == 0){
            	continue;
            }
            
            match = FHSPROD.labelme.matchLabel(product, label, image, FHSPROD.labelme.showMatchLabelCollection);
            
            if (match) {
                match_count++;
                if(FHSPROD.labelme.settings.show_multiple_labels && FHSPROD.labelme.settings.show_multiple_labels == 1){
                	continue;
                }else{
                	break;
                }
            } else {
                continue;
            }
            
        }
        return null;
    };
	
	function containerPadding($imageParent, $newNode){
		//check padding of imageParent
		//var matches;
		//matches = paddingLeft.match(/(\d+)(\w{2,3})/);
		
		var padding = $imageParent.css('padding-left');
		if(padding != ''){
			$newNode.css('margin-left', padding);
		}
		padding = $imageParent.css('padding-right');
		if(padding != ''){
			$newNode.css('margin-right', padding);
		}
		padding = $imageParent.css('padding-top');
		if(padding != ''){
			$newNode.css('margin-top', padding);
		}
		padding = $imageParent.css('padding-botom');
		if(padding != ''){
			$newNode.css('margin-botom', padding);
		}
	};
	function insertLabel($imageParent, label, pwidth, pheight, $newNode, display_text){
		
		if(label.size_type && label.size_type == 1){
			$newNode.css('min-height','50px').css('min-width','50px');
			$imageParent.append($newNode);
			return;
		}
		//var $newNode = jQuery(newNode);
		//var $imageParent = jQuery(imageParent);
		containerPadding($imageParent, $newNode);
		
		var deviceWidth = window.innerWidth || document.body.clientWidth;
    	if(FHSPROD.labelme.settings && FHSPROD.labelme.settings.support_mobile == 1 && FHSPROD.labelme.settings.max_mobile_screen_width >= deviceWidth){
    		if(display_text != ''){
    			var style = $newNode.children()[0].style;
    			style.transform = style.transform + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.webkitTransform  = style.webkitTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.MozTransform   = style.MozTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.msTransform   = style.msTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.OTransform   = style.OTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.transformOrigin = '25% 25%';
    			//jQuery(newNode).css('font-size','4.5vw');
    			
	    	}
    		if(label.mobile_width && label.mobile_width > 0){
    			$newNode.css('width', label.mobile_width + 'px').css('height', label.mobile_height + 'px');
				
    			$imageParent.append($newNode);
				
			}else if(FHSPROD.labelme.settings.mobile_ratio > 0){
				var newWidth = parseInt(label.width*FHSPROD.labelme.settings.mobile_ratio, 10);
				var newHeight = parseInt(label.height*FHSPROD.labelme.settings.mobile_ratio, 10);
				$newNode.css('width', newWidth + 'px').css('height', newHeight + 'px');
				
				label.mobile_width = newWidth;
				label.mobile_height = newHeight;
				
				$imageParent.append($newNode);
				
			}else{
				$imageParent.append($newNode);
			}
		}else if(FHSPROD.labelme.settings && FHSPROD.labelme.settings.support_small_viewpot == 1){
			
		    if(FHSPROD.labelme.settings.max_viewpot_ratio > 0 
		    		&& FHSPROD.labelme.settings.max_viewpot_ratio < (label.width/pwidth)){
		    	if(display_text != ''){
		    		var style = $newNode.children()[0].style;
		    		style.transform = style.transform + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.webkitTransform  = style.webkitTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.MozTransform   = style.MozTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.msTransform   = style.msTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.OTransform   = style.OTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.transformOrigin = '25% 25%';
		    		//jQuery(newNode).css('font-size','4.5vw');
		    	}
		    	
		    	if(label.viewpotWidth && label.viewportHeight){
		    		$newNode.css('width', label.viewpotWidth + 'px').css('height', label.viewpotHeight + 'px');
		    		$imageParent.append($newNode);
					
				}else{
			    	var newWidth = parseInt(label.width*FHSPROD.labelme.settings.viewpot_ratio, 10);
					var newHeight = parseInt(label.height*FHSPROD.labelme.settings.viewpot_ratio, 10);
					$newNode.css('width', newWidth + 'px').css('height', newHeight + 'px');
					
					label.viewpotWidth = newWidth;
					label.viewpotHeight = newHeight;
					
					$imageParent.append($newNode);
				}
		    }else{
		    	$imageParent.append($newNode);	
		    }
		}else{
			$imageParent.append($newNode);
		}
    };
    FHSPROD.labelme.showMatchLabelCollection = function (product, label, image, display_text ){
    	
        var $productImage = jQuery(image);

        var img = jQuery('img', $productImage);
        var pheight = $productImage.height();
        var pwidth = $productImage.width();
        
        if( pheight == 0 && img.length > 0){
        	pheight = img[0].height;	
        }
        if(pwidth == 0 && img.length > 0){
        	pwidth =img[0].width;	
        }
        
    	var $imageParent = jQuery(image).parent(':not(a)').first();
    	//var $parent = $imageParent.parent();
    	//$imageParent.detach();
    	
    	$imageParent.addClass('fhs-parent');
        /*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function (i, p) {
        	jQuery(p).parents(':not(a)').first().addClass('fhs-parent');
        });*/
        if(FHSPROD.labelme.settings.wrap_exact_img_tag == 1){
        	if($productImage.find('img').length > 0){
        		$imageParent = $productImage.find('img');
        	}
    		var $plcontainer = jQuery('<div class=\"fhs-wrapper fhs-collection\">').css({
            	//TODO optional fix width
                //width: $productImage.width(),
                //height: $productImage.height(),
                //'margin-left': FHSPROD.getMarginW($productImage),
                //'margin-right': FHSPROD.getMarginW($productImage),
                //'margin-top': FHSPROD.getMarginH($productImage),
                //'margin-bottom': FHSPROD.getMarginH($productImage),
                //'position': 'relative',
                //padding: FHSPROD.getPadding($productImage),
            });
    		$imageParent.eq(0).wrap($plcontainer);
    		//$imageParent = $productImage.find('.fhs-wrapper');
    		$imageParent = jQuery(image).parent(':not(a)').find('.fhs-wrapper');

    	}else if(FHSPROD.labelme.settings.add_wrapper == 1){
        	var $plcontainer = jQuery('<div class=\"fhs-wrapper fhs-collection\">').css({
            	//TODO optional fix width
                //width: $productImage.width(),
                //height: $productImage.height(),
                'margin-left': FHSPROD.getMarginW($productImage),
                'margin-right': FHSPROD.getMarginW($productImage),
                'margin-top': FHSPROD.getMarginH($productImage),
                'margin-bottom': FHSPROD.getMarginH($productImage),
                'position': 'relative',
                padding: FHSPROD.getPadding($productImage),
            });
        	$imageParent.eq(0).wrap($plcontainer);
        	/*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function (i, p) {
            	jQuery(p).parents(':not(a)').eq(0).wrap(fhswrapper);
            });*/
    	}else{
    		$imageParent.css({'position': 'relative'});
		
		/*var imageParent = jQuery(image).parents(':not(a)').first();
    		imageParent.addClass('fhs-parent');
    		imageParent.css({'position': 'relative'});*/
		
    		/*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function (i, p) {
            	jQuery(p).parents(':not(a)').first().css({
                    'position': 'relative'
                })
            });*/
    	}
    	var $labelNodes = $imageParent.find('.fhs-image[data-label-id=\"' + label.id + '\"]', image);
        if ($labelNodes.length > 0) {
            $labelNodes.first().show();
        } else {
            /*var newNode = '<div data-label-id="' + label.id + '" class="fhs-image ' + label.collectionImage.position + '" style="background-size: cover; background-image: url(' + label.collectionImage.image + '); width: ' + (label.collectionImage.label_width ? label.collectionImage.label_width : 30) + (label.collectionImage.fixed_size ? 'px' : '%') + '; height: ' + (label.collectionImage.label_height ? label.collectionImage.label_height : 30) + (label.collectionImage.fixed_size ? 'px' : '%') + ';position:absolute;">';*/
        	
    		
    		var $newNode = jQuery('<div>');
    		$newNode.attr('data-label-id',label.id ).attr('class','fhs-image ' + label.css_class ).attr('style', label.div_style+ label.css_inline);
    		var $textNode = jQuery('<div>');
    		$textNode.attr('style',label.text_style).text(display_text);    
    		$newNode.append($textNode);
    		
    		
    		var pos = label.position;
    		//var style = 'position: absolute;';
    		$newNode.css('position', 'absolute');
    		if('custom' == pos){
    			//top left already in div_style
    		}else if('topleft' == pos){
    			//style += 'top:0%;left:0%;';
    			$newNode.css('top', '0%');
    			$newNode.css('left', '0%');
    		}else if('topright' == pos){
    			//style += 'top:0%;right:0%;';
    			$newNode.css('top', '0%');
    			$newNode.css('right', '0%');
    		}else if('topcenter' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'top:0%;left:'+ csize + '%'+';';
    			$newNode.css('top', '0%');
    			$newNode.css('left', csize+'%');
    		}else if('bottomleft' == pos){
    			//style += 'bottom:0%;left:0%;';
    			$newNode.css('bottom', '0%');
    			$newNode.css('left', '0%');
    		}else if('bottomright' == pos){
    			//style += 'bottom:0%;right:0%;';
    			$newNode.css('bottom', '0%');
    			$newNode.css('right', '0%');
    		}else if('bottomcenter' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'bottom:0%;left:'+ csize + '%'+';';
    			$newNode.css('bottol', '0%');
    			$newNode.css('left', csize + '%');
    		}else if('leftcenter' == pos){
    			var csize = label.size_type==0?(((pheight-label.height)/2)/pheight)*100:(((100-label.height)/2));
    			//style += 'top:'+ csize + '%'+';left:0%;';
    			$newNode.css('top', csize + '%');
    			$newNode.css('left', '0%');
    		}else if('rightcenter' == pos){
    			var csize = label.size_type==0?(((pheight-label.height)/2)/pheight)*100:(((100-label.height)/2));
    			//style += 'top:'+ csize + '%'+';right:0%;';
    			$newNode.css('top', csize + '%');
    			$newNode.css('right', '0%');
    		}else if('center' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'top:'+ csize + '%'+';left:'+ csize + '%'+';';
    			$newNode.css('top', csize + '%');
    			$newNode.css('left',csize + '%');
    		}
    		
    		insertLabel($imageParent, label, pwidth, pheight, $newNode, display_text);
    		
            //jQuery('.fhs-wrapper', element).prepend(newNode)
			//jQuery('.fhs-wrapper .fhs-parent').prepend(newNode)
            /*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function (i, p) {
            	jQuery(p).parents(':not(a)').first().append(newNode)
            });*/
        }
        //$parent.append($imageParent);
    };
	function loadCSS(href) {
		var cssLink = $('<link rel=\"stylesheet\" type=\"text/css\" href=\"'+href+'\">');
		jQuery('head').append(cssLink);
	};
	function loadFont(fontName) {
		loadCSS('https://fonts.googleapis.com/css?family=' + fontName);
	};
    function findProductListImages() {
    	//04 April 2017:  remove below criteria to allow display label on related products
    	//:not(.related-products a[href*=\"/products/\"]) 
        var productImages;
        
        if(FHSPROD.themeName == 'simple' || FHSPROD.themeName == 'jumpstart'){
        	productImages = jQuery('a[href*=\"/products/\"]:not([href*=\".jp\"]):not(form a[href*=\"/products/\"]):not([href*=\".JP\"]):not([href*=\".png\"]):not([href*=\".PNG\"]):not(.share-twitter):not(.share-facebook):not(.share-pinterest):not(.share-google)').has('img[src*=\"/products/\"], img[src*=\"/no-image\"]');	
        }else{
        	productImages = jQuery('figure > a[href*=\"/products/\"]:not([href*=\".jp\"]):not(form a[href*=\"/products/\"]):not([href*=\".JP\"]):not([href*=\".png\"]):not([href*=\".PNG\"]):not(.share-twitter):not(.share-facebook):not(.share-pinterest):not(.share-google)');
        }
        //22 July 2017: remove below search condition to support lazy loading and ajax themes 
        //.has('img[src*=\"/products/\"], img[src*=\"/no-image\"]');
        
        /*var products = {};
        productImages.each(function (index, product) {
            var splits = jQuery(product).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            products[handle] = product
        });
        return products*/
        return productImages;
    };

    function findProductMainImages() {
    	var img_src = '';
    	var first_src = '';
    	if(FHSPROD.labelme.product_main.images[0]){
    		first_src = FHSPROD.labelme.product_main.images[0].src;
    		img_src = FHSPROD.labelme.product_main.images[0].src;
    		img_src = img_src.substr(0, img_src.indexOf('.'));
    	}
    	var i;
    	var matches;
		var images = [];
    	var allImages = jQuery('img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".jp\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".JP\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".png\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".PNG\"]');
    	if(FHSPROD.labelme.settings.show_on_all_variant_images == 0 && img_src != '')
    	{
    		//find the first image
    		var firstImages;
    		if(FHSPROD.themeName == 'minimal'){
    			firstImages = allImages;
    		}else{
    			firstImages = jQuery('img[src*=\"'+img_src+'\"]');
    		}
    		if(firstImages.length > 0){
				for(i=0; i<firstImages.length; i++){
					matches = firstImages[i].src.match(/(.*\/[\w\-\_\.]+)(\_compact|\_thumb|\_pico|\_small|\_icon|\_medium|\_grande|\_1024x1024|\_master)\.(\w{2,4})/);
					if(matches && matches[2] && matches[2] != '_thumb' && matches[2] != '_pico' && matches[2] != '_small' && matches[2] != '_icon' && matches[2] != '_compact'
						&& jQuery(firstImages[i]).is(':visible')){
						images.push(firstImages[i]);
						if(FHSPROD.themeName != 'minimal' && FHSPROD.labelme.settings.stop_on_first_image == 1){
							break;
						}
					}else if(jQuery(firstImages[i]).is(':visible')){
						images.push(firstImages[i]);
						if(FHSPROD.themeName != 'minimal' && FHSPROD.labelme.settings.stop_on_first_image == 1){
							break;
						}
					}
				}
				if(images.length == 0 && allImages.length > 0){
					images.push(firstImages[0]);
				}
				/*if(images.length == 0 && allImages.length > 0 && firstImages[0].src == allImages[0].src){
					images = firstImages[0];	
				}else if (allImages.length > 0 ){
					images = allImages[0];
				}else{
					images = firstImages[0];
				}*/
				if(FHSPROD.themeName == 'minimal'){
					var maxWidth = 0;
			        var mainImage;
			       jQuery( images).each(function (index, image) {
			            var currentWidth = image.width;
			            if (currentWidth > maxWidth) {
			                maxWidth = currentWidth;
			                mainImage = image
			            }
			        });
			        return jQuery(mainImage)
				}
    		}else if (allImages.length > 0 ){
    			images.push(allImages[0]);
			}
			//falback check :to make sure at least 1 image selected
			if(images.length == 0 && firstImages.length > 0){
				images.push(firstImages[0]);
			}
    	}else{ //display on all images
			
			var pimage;
			var ilen = allImages.length;
			//for(var i=0; i< ilen; i++){
				//var aimage = allImages[i];

				for(var j=0; j<FHSPROD.labelme.product_main.images.length; j++){
					pimage = FHSPROD.labelme.product_main.images[j];
					matches = pimage.src.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
					if(matches && matches[1] && matches[1].length > 0){
						var matchImages = jQuery('img[src*=\"'+matches[1]+'\"]');
						if( matchImages.length > 0){
							images.push(matchImages);
						}
					}
				}
			//}
			//fallback check: to make sure images selected
			if(images.length == 0 ){
				var imageQuery = '';
				for(i=0; i<FHSPROD.labelme.product_main.images.length; i++){
					imageQuery += 'img[src*=\"'+FHSPROD.labelme.product_main.images[i].src+'\"],' ;
				}
				imageQuery = imageQuery.replace(/,(?=[^,]*$)/, '');
				images.push(jQuery(imageQuery));
			}
    	}
    	return images;
    };

    function getVariantId() {
        var variantId = null;
		return variantId;
		// if(Shopify.urlParam){
			// variantId= Shopify.urlParam('variant');
		// }
        // if (!variantId) {
            // var elem = document.getElementById(Shopify.OptionSelectors.domIdPrefix);
            // if (!elem) {
                // return false
            // }
            // var option = elem.querySelector('[selected]');
            // if (!option) {
                // return false
            // }
            // variantId = option.value
        // }
        // return variantId
    };
    
    function executeQuery(arrProductImages, queryUrl){

    	jQuery.ajax({
            url: queryUrl,
            dataType: 'text',
            type: 'post',
            success: function (text) {
            	 //console.debug(text);
            	try{
            		if(text.indexOf('START_FHSPROD') >=0){
            			text = text.substring(text.indexOf('START_FHSPROD')+13, text.lastIndexOf('END_FHSPROD'));
            		}
            		json = JSON.parse(text);
            	//console.debug(json)
            		if(json && json.results){
		            	var rlen = json.results.length;
		            	for(var i=0; i<rlen; i++){
		                	FHSPROD.labelme.products[json.results[i].handle] = json.results[i];
		                }
		                showLabels(arrProductImages);
            		}
            	}catch(err){
            		console.error(err);
            	}
    		}
    	});
    };
    function searchMainProductByHandle(queryUrl){

    	jQuery.ajax({
            url: queryUrl,
            dataType: 'text',
            type: 'post',
            success: function (text) {
            	try{
            		//json = JSON.parse(text.substring(text.indexOf('START_FHSPROD')+13, text.lastIndexOf('END_FHSPROD')));
            		if(text.indexOf('START_FHSPROD') >=0){
            			text = text.substring(text.indexOf('START_FHSPROD')+13, text.lastIndexOf('END_FHSPROD'));
            		}
            		json = JSON.parse(text);
            		if(json && json.results){
	            		var rlen = json.results.length;
	            		for(var i=0; i<rlen; i++){
	            			FHSPROD.labelme.product_main = json.results[i];
	            			var images = findProductMainImages();
	            			
	            			var ilen = images.length;
	            			for(var i=0; i<ilen; i++){
	            				var $image = jQuery(images[i]);
	            				FHSPROD.labelme.labelMain(FHSPROD.labelme.product_main.variants[0].id, $image);
	            			}
	            			break;
	            		}
            		}
            	}catch(err){
            		console.debug(err);
            	}
    		}
    	});
    };
    FHSPROD.labelme.productImages = {};
    function queryProduct(arrProductImages){
    	var fullQuery = '';
        var idx = 0;
        var startSlice = 0;
        var ilen = arrProductImages.length;
        var arrProductImagesQuery = [];
    	for(var i = 0; i<ilen; i++){
        //arrProductImages.each(function (index, product) {
    		var product = arrProductImages[i];
            var splits = jQuery(product).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            if(handle.indexOf('#') > 0){
            	handle = handle.substring(0, handle.indexOf('#'));
            }
            //console.debug('handle='+handle);
            
            //14-JAN-2018 get meta data
            if(jQuery('#fhs_meta_'+handle).length > 0){
            	//console.debug(jQuery('#fhs_meta_'+handle).get(0).innerText);
            	var prodmeta = JSON.parse(jQuery('#fhs_meta_'+handle).get(0).innerText);
            	//console.debug(prodmeta);
            	FHSPROD.labelme.products[handle] = prodmeta;
            	
            	showLabels_Single(product, handle);
            }else{
            	idx++;
            	
            	//put to query array
            	arrProductImagesQuery.push(product);
            	
            	//search by handle
	            if (fullQuery.length > 0) {
	                fullQuery += " OR ";
	            }
	            fullQuery += 'handle:\"' + handle + '\"';
	            
	            if (idx >= 20 && arrProductImagesQuery.length > 0) {
	            	fullQuery = '/search.js?view=fhsprod-labelme-json&q=' + fullQuery;
	            	//executeQuery(arrProductImages.slice(startSlice, startSlice+idx), fullQuery);
	            	executeQuery(arrProductImagesQuery, fullQuery);
	            	arrProductImagesQuery = [];
	            	startSlice += idx;
	            	fullQuery = '';
	            	idx = 0;
	            }
            }
        //});
    	}
        if (idx > 0 && arrProductImagesQuery.length > 0) {
        	fullQuery = '/search.js?view=fhsprod-labelme-json&q=' + fullQuery;
        	//executeQuery(arrProductImages.slice(startSlice, startSlice+idx), fullQuery);
        	executeQuery(arrProductImagesQuery, fullQuery);
        	fullQuery = '';
        }
    };
    
    function showLabels(arrProductImages){
    	var ilen = arrProductImages.length;
    	for(var i=0; i<ilen; i++){
    		var productImage = arrProductImages[i];
    	//arrProductImages.each(function (index, productImage) {
            var splits = jQuery(productImage).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            if(handle.indexOf('#') > 0){
            	handle = handle.substring(0, handle.indexOf('#'));
            }
            
            //save productImage[handle] for future use
            if (!FHSPROD.labelme.productImages.hasOwnProperty(handle)) {
            	FHSPROD.labelme.productImages[handle] = productImage;
            }
            
            var product = FHSPROD.labelme.products[handle];
            if(product){
            	FHSPROD.labelme.labelList(product, productImage);
            }
        //});
    	}
    };
    
    function showLabels_Single(productImage, handle){
    	//save productImage[handle] for future use
        if (!FHSPROD.labelme.productImages.hasOwnProperty(handle)) {
        	FHSPROD.labelme.productImages[handle] = productImage;
        }
        
        var product = FHSPROD.labelme.products[handle];
        if(product){
        	FHSPROD.labelme.labelList(product, productImage);
        }
    };
    
    function addClassCss() {
    	var cssVal = '';
    	if(FHSPROD.labelme.settings.scale_on_hover == 1){
    		cssVal = 'div.fhs-image:hover{ -webkit-transition: all 200ms ease-in!important;'
    	    	+'-webkit-transform: scale(1.1)!important;'
    	        +'-ms-transition: all 200ms ease-in!important;-ms-transform: scale(1.1)!important;-moz-transition: all 200ms ease-in!important;-moz-transform: scale(1.1)!important;'
    	        +'transition: all 200ms ease-in!important;transform: scale(1.1)!important;}'
    	        +'';	
    	}
    	if(FHSPROD.themeName && FHSPROD.themeName == 'venture'){
    		cssVal += 'div.fhs-wrapper {height: 255px;margin-bottom: 60px;}';
    	}
    	
    	jQuery('<style>').attr('type', 'text/css').html(cssVal).appendTo('head');
	};
	function processCollectionLabels(thirdPartiesProductImages){
		
		if ( (typeof FHSPROD.labelme.settings.show_collection_page == 'undefined' || FHSPROD.labelme.settings.show_collection_page == 1)
        		&& (typeof FHSPROD.labelme.pg === 'undefined' 
        			|| FHSPROD.labelme.pg == 'collection' 
        				|| FHSPROD.labelme.pg == '' 
        					|| FHSPROD.labelme.pg == 'product')) {
            var arrProductImages; 
            if(typeof thirdPartiesProductImages == 'undefined'){
            	arrProductImages = findProductListImages();
            }else{
            	arrProductImages = thirdPartiesProductImages;
            }
            if(typeof FHSPROD.labelme.product_list === 'undefined')
            	FHSPROD.labelme.product_list = [];
            //FHSPROD.labelme.productImages = productImages;
            //console.debug('Go collection page');
            FHSPROD.labelme.products = {};
            if(typeof FHSPROD_product_list !== 'undefined'){
            	FHSPROD.labelme.product_list = FHSPROD_product_list;
            }
            
            if(FHSPROD.labelme.product_list){
	            jQuery.each(FHSPROD.labelme.product_list, function (i, product) {
	                FHSPROD.labelme.products[product.handle] = product;
	            });
            }
            if(FHSPROD.labelme.product_front){
	            jQuery.each(FHSPROD.labelme.product_front, function (i, product) {
	                FHSPROD.labelme.products[product.handle] = product;
	            });
            }

            if(FHSPROD.labelme.pg != 'product'
            	||(FHSPROD.labelme.pg == 'product' && (typeof FHSPROD.labelme.settings.show_product_page_related === 'undefined' 
            		|| FHSPROD.labelme.settings.show_product_page_related == 1))){
	            if(FHSPROD.labelme.product_list.length == 0){
	            	queryProduct(arrProductImages);
	            }else{
	            	showLabels(arrProductImages);
	            }
            }
            
            

            /*jQuery(window).resize(function () {
                var arrProductImages = findProductListImages();
                arrProductImages.each(function (index, productImage) {
                    $productImage = jQuery(productImage);
                    jQuery('.fhs-collection', productImage).css({
                    	//TODO optional fix width
                        //width: $productImage.width(),
                        //height: $productImage.height(),
                        'margin-left': FHSPROD.getMarginW($productImage),
                        'margin-right': FHSPROD.getMarginW($productImage),
                        'margin-top': FHSPROD.getMarginH($productImage),
                        'margin-bottom': FHSPROD.getMarginH($productImage),
                        'position': 'relative',
                        padding: FHSPROD.getPadding($productImage),
                    })
                });
            });*/
        }
	};
	function observeElement(id){
		// select the target node
		var target = document.getElementById(id);
		var timeoutVar ;
		// create an observer instance
		var observer = new MutationObserver(function (mutations) {
		  mutations.forEach(function (mutation) {
			  clearTimeout(timeoutVar);
			  timeoutVar = setTimeout(function (){processCollectionLabels(); }, 500);
		  });    
		});
		 
		// configuration of the observer:
		var config = { attributes: true, childList: true, characterData: true };
		 
		// pass in the target node, as well as the observer options
		observer.observe(target, config);
	};
	function identifyPage(){
		FHSPROD.labelme.pg = 'collection';
		var storeURL = window.location.pathname;
    	if(storeURL){
    		var matches = storeURL.match(/(.*)\/(.[products]+)\/(.*)/);
    		if(matches && matches[3]){
    			FHSPROD.labelme.pg = 'product';
    		}else if(storeURL.indexOf('collections') > 0){
				FHSPROD.labelme.pg = 'collection';
			}else if(storeURL.indexOf('blogs') > 0){
    			FHSPROD.labelme.pg = 'blog';
			}else if(storeURL.indexOf('pages') > 0){
        		FHSPROD.labelme.pg = 'page';
			}else if(storeURL.indexOf('search') > 0){
        		FHSPROD.labelme.pg = 'search';
			}
    	}
	};
    jQuery(document).ready(function () {
    	try{
	    	
    		identifyPage();
        	
	    	addClassCss();
	    	
	    	if(FHSPROD.themeName == 'brooklyn' || FHSPROD.themeName == 'pop' || FHSPROD.themeName == 'supply' 
	    		|| FHSPROD.themeName == 'narrative' || FHSPROD.themeName == 'minimal' || FHSPROD.themeName == 'boundless' 
	    			|| FHSPROD.themeName == 'venture' || FHSPROD.themeName == 'simple' || FHSPROD.themeName == 'debut'
	    				|| FHSPROD.themeName == 'jumpstart' || FHSPROD.themeName == 'launchpad'){
	    		FHSPROD.labelme.settings.wrap_exact_img_tag = 0;
	    	}
	    	
	        jQuery('div.fhs-wrapper').remove();
	        //load fonts
	        var llen = FHSPROD.labelme.labels.length;
	        for(var i=0; i<llen; i++ ){
	        	var label = FHSPROD.labelme.labels[i];
	            if(label.font_name){
	            	loadFont(label.font_name);
	            }
	        }
	        if(typeof FHSPROD.labelme.pg === 'undefined' && (typeof FHSPROD.labelme.settings.show_product_page === 'undefined' 
	        	|| FHSPROD.labelme.settings.show_product_page == 1))
	        {
	        	var storeURL = window.location.pathname;
	        	if(storeURL){
	        		var matches = storeURL.match(/(.*)\/(.[products]+)\/(.*)/);
	        		if(matches && matches[3]){
	        			FHSPROD.labelme.pg = 'product';
	        			storeURL = matches[3];
	        			if (storeURL.indexOf("?")>-1){
	        				storeURL = url.substr(0,storeURL.indexOf("?"));
	        			}
	    				//search product main
						 var q = 'handle:\"' + storeURL + '\"';
				         q = '/search.js?view=fhsprod-labelme-json&q=' + q;
				         searchMainProductByHandle(q);
	        		}
	        	}
	        }else if (FHSPROD.labelme.pg == 'product' && (typeof FHSPROD.labelme.settings.show_product_page === 'undefined' 
	        	|| FHSPROD.labelme.settings.show_product_page == 1)) {
	
	        	var images = findProductMainImages();
				
	        	var ilen = images.length;
	        	for(var i=0; i<ilen; i++){
	        		var image = images[i];
					if (image) {
						var variantId = getVariantId();
						if (!variantId) {
							variantId = FHSPROD.labelme.product_main.variants[0].id;
						}
						FHSPROD.labelme.labelMain(variantId, jQuery(image));
					}
	        	}
	        }
	        
	        processCollectionLabels();
			
	        jQuery('.fhs-image').css('display','block');
			
			//observe element
			//observeElement('collection-grid');
			
	        //re check after 2 seconds
			if (typeof FHSPROD.labelme.settings.show_collection_page == 'undefined'  
				|| FHSPROD.labelme.pg == 'product') {
				setTimeout(function (){processCollectionLabels(); }, 2000);
			}
    	}catch(e){
    		console.error(e);
    	}
    }); //end document.ready
};
if (FHSPROD.labelme.loadedJs === true) {
    FHSPROD.labelme.jQuery(document).ready(function () {
        labelInit(FHSPROD, FHSPROD.labelme.jQuery);
    });
} else {
    if (typeof jQuery === 'undefined') {
        loadScript('//code.jquery.com/jquery-1.11.1.min.js', function () {
            FHSPROD.jQuery = jQuery.noConflict(true);
            FHSPROD.jQuery(document).ready(function () {
                labelInit(FHSPROD, FHSPROD.jQuery);
            });
        });
    } else {
        jQuery(document).ready(function () {
            labelInit(FHSPROD, jQuery);
        });
    }
}